import { render, staticRenderFns } from "./EditActivitiesDialog.vue?vue&type=template&id=5f11ca1b&scoped=true&"
import script from "./EditActivitiesDialog.vue?vue&type=script&lang=js&"
export * from "./EditActivitiesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f11ca1b",
  null
  
)

export default component.exports